import { useState, useEffect, useMemo, useCallback } from "react";
import { getCases } from "../../../api/cases";

const useWikiCases = () => {
  const [cases, setCases] = useState([]);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const loadCases = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getCases();
      const data = response?.data || [];
      setCases(data);
      // auto-select first case if none selected
      if (!currentCompany && data.length > 0) {
        setCurrentCompany(data[0].case);
      }
    } catch (e) {
      console.error("Error loading cases:", e);
      setCases([]);
    } finally {
      setIsLoading(false);
    }
  }, [currentCompany]);

  useEffect(() => {
    loadCases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const caseNames = useMemo(
    () => cases.map((c) => c.case).filter(Boolean),
    [cases],
  );

  return {
    cases,
    caseNames,
    currentCompany,
    setCurrentCompany,
    isLoading,
    loadCases,
  };
};

export default useWikiCases;
